import {
  AccountAdapterInteface,
  ListAccountsInput,
} from 'src/adapter/AccountAdapterInterface';
import {
  AccountCreateAttributes,
  AccountUpdateAttributes,
  AccountGetAttributes,
} from 'src/models/AccountModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosAccountAdapter implements AccountAdapterInteface {
  async listAccounts(
    conditions?: ListAccountsInput
  ): Promise<{ total: number; data: AccountGetAttributes[] }> {
    try {
      const res = await api.get('/accounts', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getAccount(id: string): Promise<AccountGetAttributes> {
    try {
      const res = await api.get(`/accounts/${id}`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async createAccount(
    attributes: AccountCreateAttributes
  ): Promise<AccountGetAttributes> {
    try {
      const res = await api.post('/accounts', attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateAccount(
    id: string,
    attributes: AccountUpdateAttributes
  ): Promise<AccountGetAttributes> {
    try {
      const res = await api.put(`/accounts/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async deleteAccount(id: string): Promise<boolean> {
    try {
      return await api.delete(`/accounts/${id}`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
